<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p9"><span class="sz"><b>Dedication</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p2"><span class="sz"> </span></p>
<p class="p4"><span class="sz">Tim, Pandora, and Jasper</span></p>
<p class="p4"><span class="sz">my three constants</span></p>
<p class="p4"><span class="sz">With love</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section4.vue?af3deb88